import { siteStats } from "@/mocks/homeData";

export default function StatsStrip() {
  return (
    <section className="w-full border-b border-background-200/70 bg-background-100">
      <div className="mx-auto grid w-full grid-cols-2 gap-y-6 px-4 py-8 md:grid-cols-4 md:px-6 md:py-10">
        {siteStats.map((s, i) => (
          <div
            key={s.label}
            className={`flex flex-col items-center justify-center px-2 ${
              i < siteStats.length - 1 ? "md:border-r md:border-background-300/70" : ""
            }`}
          >
            <span className="font-heading text-2xl font-bold text-primary-600 md:text-3xl">
              {s.value}
            </span>
            <span className="mt-1 text-xs tracking-wide text-foreground-500 md:text-sm">
              {s.label}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}